import { SET_PREORDER_DATA } from "../actions";

const preorderData = (state = {}, action) => {
  if (action.type === SET_PREORDER_DATA) {
    return action.payload;
  }
  return state;
};

export default preorderData;



// WEBPACK FOOTER //
// ./src/store/reducers/preorderRedcuer.js